import { NewFleet, type Fleet } from './fleet';

type Parties = {
    attackers: Party
    defenders: Party
}

type PartyKey = keyof Parties
const PartyMembers: PartyKey[] = ['attackers', 'defenders']

type Party = {
    fleets: Fleet[]
}

function NewParties(): Parties {
    return {
        attackers: { fleets: [NewFleet(false)] },
        defenders: { fleets: [NewFleet(true)] }
    }
}

export type {
    Parties,
    PartyKey,
    Party
}

export {
    PartyMembers,
    NewParties,
}